<template>
  <div class="login">
    <div class="pic-left">
      <div class="inner-pic">
        <img v-if="language === 'hk' || language === 'en'" src="@/icon/newBg/login_IMG_zx.png" />
        <img v-else-if="!isHuaWei" src="@/icon/login-img-zx.png" />
        <img v-else src="@/icon/login-img.png" />
      </div>
    </div>
    <div class="login-table">
      <div class="login_top">
        <!-- 公有云 标题头部 -->
        <div v-if="!customer && isCloud">
          <span v-if="language !== 'en'">
            <img v-if="isHuaWei" src="@/icon/login-top2.png" />
            <img v-else src="@/icon/login-img-hw.png" />
          </span>
          <span class="company-name" v-else>{{ $t('现场作业智能管控平台') }}</span>

        </div>

        <!-- 私有化 标题头部 -->
        <div v-else>
          <img class="top-icon" v-if="SYS_ICON" :src="SYS_ICON" />
          <span class="company-name" v-if="SYS_NAME">{{ $t(SYS_NAME) }}</span>
        </div>
      </div>
      <!-- 忘记密码开始 -->
      <div class="login_com" v-if="forgetVisible">
        <el-form :model="forgetFrom" :rules="forgetRules" ref="forgetFrom">
          <div class="login_title">
            <span>{{ $t('forgotPassword') }}</span>
          </div>
          <el-form-item label="" prop="phone" style="margin-bottom: 1px !important;">
            <div class="login_username">
              <i slot="suffix" class="icon_phone"></i>
              <el-input
                :placeholder="$t('enterMobileNum')"
                v-model="forgetFrom.phone"
                class="input_username"
                autocomplete="off"
                readonly
                onfocus="this.removeAttribute('readonly');"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="" prop="newPassword" style="margin-bottom: 1px !important;">
            <div class="login_password">
              <i slot="suffix" class="icon_password"></i>
              <el-input
                :type="newPassVisible ? 'text' : 'password'"
                :placeholder="$t('setNewLoginPass')"
                v-model="forgetFrom.newPassword"
                class="input_password"
                autocomplete="off"
              ></el-input>
              <img
                :src="require(passVisible ? '@/icon/password-visible.png' : '@/icon/password-not-view.png')"
                @click="showPass('forget')"
                class="icon-show"
              />
            </div>
          </el-form-item>

          <el-form-item label="" style="margin-bottom: 1px !important;">
            <div class="login_password">
              <i slot="suffix" class="icon_code"></i>
              <el-input
                type="text"
                :placeholder="$t('phoneVerificationCode')"
                v-model="forgetFrom.code"
                class="input_password"
                autocomplete="off"
              ></el-input>
              <span class="phoneCode" :disabled="disabled" @click="getsmsCode('forget')">{{ btnTxt }}</span>
            </div>
          </el-form-item>

          <div class="login_btn">
            <el-button class="" @click="toReset">{{ $t('determine') }}</el-button>
            <p class="back-login" @click="forgetPass('back')">{{ $t('backToLogin') }}</p>
          </div>
        </el-form>
      </div>
      <!-- 忘记密码结束 -->
      <div v-else>
        <div class="login_com" v-if="mode === false">
          <!-- 账号密码/手机登录开始 -->
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="$t('accountPasswordLogin')" name="first">
              <div class="login_username">
                <i slot="suffix" class="icon_username"></i>
                <input
                  :placeholder="$t('enterAccountNum')"
                  v-model="username"
                  class="input_username"
                  autocomplete="on"
                />
              </div>
              <div class="login_password">
                <i slot="suffix" class="icon_password"></i>
                <input
                  :type="passVisible ? 'text' : 'password'"
                  :placeholder="$t('enterLoginPassword')"
                  v-model="password"
                  class="input_password"
                  @keyup.enter="login"
                />
                <img
                  :src="require(passVisible ? '@/icon/password-visible.png' : '@/icon/password-not-view.png')"
                  @click="showPass('login')"
                  class="icon-show"
                />
              </div>
              <!-- 图形验证码 -->
              <div class="login_code" v-if="showCode">
                <i slot="suffix" class="icon_code" v-if="verticalSucc"></i>
                <i slot="suffix" class="vertical_err" v-else></i>
                <input
                  class="input_code"
                  v-model="validateCode"
                  auto-complete="off"
                  :placeholder="$t('enterVerification')"
                  clearable
                  @input="checkVerificationCode"
                  @keyup.enter="login"
                />
                <div @click="refreshCode" class="refreshCode">
                  <img :src="codeUrl" alt="看不清楚？换一张" @click="refreshClick" />
                </div>
              </div>
              <div class="login_checkbox">
                <span @click="forgetPass('go')" v-if="isCloud">{{ $t('forgotPassword') }}</span>
                <span class="word">
                  {{ $t('chooseLanguage') }}:
                  <el-select v-model="language" placeholder="" @change="onSwitchLanguage">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </span>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('mobileLogin')" name="second" v-if="isHuaWei && isCloud">
              <div class="login_username">
                <i slot="suffix" class="icon_phone"></i>
                <input :placeholder="$t('enterMobileNum')" v-model="username" class="input_username" autocomplete="on" />
              </div>
              <div class="login_password">
                <i slot="suffix" class="icon_code"></i>
                <input type="text" :placeholder="$t('phoneVerificationCode')" v-model="password" class="input_password" />
                <span class="phoneCode" :disabled="disabled" @click="getsmsCode('login')">{{ btnTxt }}</span>
              </div>
            </el-tab-pane>
          </el-tabs>

          <div class="login_btn">
            <el-button class="" @click="login">{{ $t('loginL') }}</el-button>
            <div class="login-hint">
              {{ loginErrorHint }}
            </div>
          </div>
          <img
            class="QRBtn"
            v-if="isHuaWei && isCloud"
            @click="loginMode(mode)"
            :src="require(!mode ? '@/icon/ic_qr.png' : '@/icon/ic_pc.png')"
            alt=""
          />
        </div>
        <div class="weixin" v-if="mode && isCloud">
          <div id="wxbox">
            <wxlogin
              :appid="appid"
              :scope="scope"
              :redirect_uri="encodeURIComponent(qrcodeUrl)"
              :state="state"
              :href="href"
            ></wxlogin>
          </div>
          <img
            class="QRBtn"
            @click="loginMode(mode)"
            :src="require(!mode ? '@/icon/ic_qr.png' : '@/icon/ic_pc.png')"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 公有云 页脚备案 -->
    <div class="bottom_info" v-if="isCloud">
      <img v-if="isHuaWei" src="@/icon/bottom_logo2.png" alt="" />
      <span v-if="isHuaWei" @click="tolink"
        >Copyright © 1997-{{ _year }} 华微软件版权所有 | 华微软件 设计制作维护 | "二郎神"为广州华微明天软件技术有限公司注册商标 |
      </span>
      <span @click="tolink">粤ICP备07033676号</span>
      <span v-if="isHuaWei" @click="toHelp"> | {{ $t('help') }}</span>
    </div>
    <!-- 私有化  页脚备案-->
    <div class="bottom_info" v-else>
      <img :src="CPMPANY_ICON" alt="" />
      <span @click="tolink">{{ $t(SYS_WEBSITE) }}</span>
    </div>
    <div class="box"></div>
  </div>
</template>
<script>
import { getCookie, setSession, getSession, getUrlParam } from '@/api/common'
import { Message } from 'element-ui'
import { createSocket } from '@/api/websocket'
import { creatGK3Socket } from '@/common/websocket/index'
import wxlogin from 'vue-wxlogin'
import { loginWalkie } from '@/common/rtc/mediasoup/mediasoup-walkie'
import { getRealVideoUrl } from '@/api/iam-manage/config'
import { loginMVCPUtil } from '@/common/rtc/mediasoup/mediasoup-util'
import { register } from '@/common/rtc/srs/video-platform'
import { walkieRegist } from '@/common/rtc/srs/video-walkie'
import { mapGetters } from 'vuex'
import { loginStorage } from '@/common/loginStorage'
import { loginCodeUrl } from '@/api/config'
import { getLogin, getCodePic, smsSend, resetOauthPassword, getRecordFlag } from '@/api/login'
import { loginCollection } from '@/api/dmp/dmpCollection'
import { encrypt } from '@/util/rsaEncryptor'
import { getQrCode } from '@/api/personal'
import { getMapCenter } from '@/api/fence'
import { changeFavicon } from '@/util/common'
// 手机号正则校验
export default {
  components: {
    wxlogin,
  },
  data() {
    return {
      forgetRules: {
        phone: [
          { required: true, message: this.$t('digitMobilePhoneNumber'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const regMobile = /^((\(\d{2,3}\))|(\d{3}\-))?1[3|5|8]\d{9}$/
              if (!value) {
                return callback(new Error(this.$t('enterYourMobile')))
              }
              if (!regMobile.test(value)) {
                callback(new Error(this.$t('mobilePhoneIncorrect')))
              }
            },
            trigger: 'blur',
          },
          { min: 11, message: this.$t('enterAtLeastCharacters'), trigger: 'blur' },
        ],
        newPassword: [
          { required: true, message: this.$t('setNewLoginPass'), trigger: 'blur' },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              var passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/
              if (!passwordreg.test(value)) {
                callback(new Error(this.$t('mustBeCombinationNumbers')))
              } else {
                callback()
              }
            },
          },
        ],
      },
      loginErrorHint: '',
      // 登录账户
      username: '',
      // 登录密码
      password: '',
      checked: false,
      // 显示图形验证码
      showCode: false,
      // 图形验证码
      identifyCode: '',
      // 需要输入验证码
      validateCode: '',
      // 验证码随机取数值
      identifyCodes: '1234567890',
      codeUrl: loginCodeUrl,
      // 显示密码 的改变
      passVisible: false,
      // 输入验证码正确图标显示
      verticalSucc: false,
      // 登录方式绑定参数
      activeName: 'first',
      // 加密密码参数
      rsaPassWord: '',
      // 登录密码类型
      auth_type: '',
      mode: false,
      // 是否禁止点击
      disabled: false,
      // 获取验证码倒计时
      time: 60,
      btnTxt: this.$t('getVerificationCode'),
      qrcodeUrl: '',
      routeNow: '',
      // 显示忘记密码入口
      forgetVisible: false,
      // 忘记密码表单参数
      forgetFrom: {
        phone: '',
        code: '',
        newPassword: '',
      },
      newPassVisible: false,
      scope: '',
      appid: '',
      href: '',
      state: '',
      // 定时循环变量
      myVar: '',
      // 预防登录按钮重复点击
      hasRemind: false,
      markerPoint: {
        lng: 113.345889,
        lat: 23.127319,
      },
      language: localStorage.getItem('lang'),
      WechatCode: [],
      options: [{
          value: 'zh',
          lang: 'zh',
          label: '简体'
        },
        {
          value: 'hk',
          lang: 'hk',
          label: '繁体'
        },
        {
          value: 'en',
          lang: 'en',
          label: 'English'
        }]
    }
  },
  methods: {
    onSwitchLanguage(lang) {
      localStorage.setItem('lang', lang)
      this.$i18n.locale = lang
      // 部分资源需要刷新
      setTimeout(() => {
        window.location.reload()
      }, 0)
    },
    // 忘记密码
    toReset() {
      // 校验输入的参数
      if (this.forgetFrom.phone === '') {
        Message({
          type: 'error',
          message: this.$t('enterMobileNum'),
          duration: 1000,
        })
      } else if (this.forgetFrom.newPassword === '') {
        Message({
          type: 'error',
          message: this.$t('setNewLoginPass'),
          duration: 1000,
        })
      } else if (this.forgetFrom.code === '') {
        Message({
          type: 'error',
          message: this.$t('phoneVerificationCode'),
          duration: 1000,
        })
      } else {
        let param = new FormData()
        param.append('phone', this.forgetFrom.phone)
        param.append('pwd', encrypt(this.forgetFrom.newPassword))
        param.append('code', this.forgetFrom.code)
        resetOauthPassword(param).then(res => {
          if (res.state === 0) {
            this.forgetVisible = false
            Message({
              type: 'success',
              message: this.$t('MmodificationSucceeded'),
              duration: 1000,
            })
          }
        })
      }
    },
    forgetPass(type) {
      clearTimeout(this.timer)
      this.forgetVisible = type === 'go' ? true : false
    },
    // 二维码登录方式切换
    loginMode() {
      clearInterval(this.myVar)
      this.mode = !this.mode
      this.username = ''
      this.password = ''
      if (this.mode !== false) {
        this.activeName = ''
        this.getWxCode()
      } else {
        this.activeName = 'first'
      }
    },
    getUrl(name, url) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ''])[1].replace(/\+/g, '%20')
        ) || null
      )
    },
    // 获取微信二维码
    getWxCode() {
      if (window.document.location.hash.indexOf('?')) {
        let routeUrl = window.document.location.hash.split('?')
        this.routeNow = routeUrl[0]
      }
      let wPath = window.document.location.origin + '/' + this.routeNow
      let param = new FormData()
      param.append('redirectUrl', wPath)
      param.append('state', 'wxLogin')
      getQrCode(param).then(res => {
        if (res.state === 0) {
          this.WechatCode = res.data
          this.appid = this.getUrl('appid', res.data.qrcodeUrl)
          this.scope = this.getUrl('scope', res.data.qrcodeUrl)
          this.qrcodeUrl = this.getUrl('redirect_uri', res.data.qrcodeUrl)
          this.state = this.getUrl('state', res.data.qrcodeUrl)
          this.href = ''
        }
      })
    },
    // 获取手机验证码
    getsmsCode(type) {
      this.time = 60
      if ((type === 'forget' && !this.forgetFrom.phone) || (type === 'login' && !this.username)) {
        Message({
          type: 'error',
          message: this.$t('enterMobileNum'),
          duration: 1000,
        })
      } else {
        let param = new FormData()
        if (type === 'forget') {
          param.append('phone', this.forgetFrom.phone)
          param.append('type', 'reset')
        } else {
          param.append('phone', this.username)
          param.append('type', 'login')
        }
        smsSend(param).then(res => {
          if (res.state === 0) {
            Message({
              type: 'success',
              message: this.$t('succeededObtainingMobile'),
              duration: 1000,
            })
            this.timer()
          }
        })
      }
    },
    timer() {
      if (this.time > 0) {
        this.disabled = true
        this.time--
        this.btnTxt = this.time + '秒'
        setTimeout(this.timer, 1000)
      } else {
        clearTimeout(this.timer)
        this.time = 0
        this.btnTxt = this.$t('sendVerificationCode')
        this.disabled = false
      }
    },
    handleClick() {
      this.username = ''
      this.password = ''
    },
    tolink() {
      window.open('https://beian.miit.gov.cn/')
    },
    showPass(type) {
      if (type === 'login') {
        this.passVisible = !this.passVisible
      } else {
        this.newPassVisible = !this.newPassVisible
      }
    },
    refreshClick() {
      this.verticalSucc = false
      let randonNum = Math.ceil(Math.random() * 100000) //生成一个随机数（防止缓存）
      this.codeUrl = loginCodeUrl + '?' + randonNum
    },
    // 验证图形验证码
    checkVerificationCode() {
      let param = {
        verificationCode: this.validateCode,
      }
      if (this.validateCode.length < 4) {
        this.verticalSucc = false
        return
      }
      getCodePic(param).then(res => {
        if (res.state === 0) {
          this.verticalSucc = true
        } else {
          this.refreshCode()
          this.verticalSucc = false
        }
      })
    },
    // 点击登录
    login() {
      if (this.hasRemind === true) return
      if (this.hasRemind === false) {
        this.hasRemind = true
        setTimeout(() => {
          this.hasRemind = false
        }, 3000)
      }
      if (this.activeName === 'first') {
        // 账号密码登录方式验证
        if (!this.username) {
          Message({
            type: 'error',
            message: this.$t('enterAccountNum'),
            duration: 1000,
          })
        } else if (!this.password) {
          Message({
            type: 'error',
            message: this.$t('pleaseInputPassword'),
            duration: 1000,
          })
        } else if (this.showCode === true && this.validateCode === '') {
          Message({
            type: 'error',
            message: this.$t('enterVerification'),
            duration: 1000,
          })
        } else {
          this.rsaPassWord = encrypt(this.password)
          this.auth_type = 'password'
          this.gologin()
        }
      } else if (this.activeName === 'second') {
        // 手机号码登录方式验证
        if (this.username === '') {
          Message({
            type: 'error',
            message: this.$t('enterMobileNum'),
            duration: 1000,
          })
        } else if (this.password === '') {
          Message({
            type: 'error',
            message: this.$t('phoneVerificationCode'),
            duration: 1000,
          })
        } else {
          this.rsaPassWord = this.password
          this.auth_type = 'phone'
          this.gologin()
        }
      }
    },
    // 请求登录接口
    gologin() {
      if (this.mode === true) {
        // 微信登录方式
        this.username = getUrlParam('state')
        this.rsaPassWord = getUrlParam('code')
        this.auth_type = 'wx_qr'
      }
      let params = {
        data: {
          username: this.username,
          password: this.rsaPassWord,
          grant_type: 'password',
          verificationCode: this.validateCode,
          auth_type: this.auth_type,
        },
      }

      getLogin(params).then(val => {
        let state = val.state
        let res = val
        if (state === 0) {
          // 储存参数
          loginStorage(res)
          // 私有化请求配置 是 mediasoup 或者 SRS
          if (!this.isCloud) {
            this.getCloudRoomUrl()
          }
          this.loginErrorHint = ''
          this.$store.dispatch('alterName', res.username)

          let permsCode = sessionStorage.getItem('featureCode')
          if (permsCode) {
            createSocket()
            creatGK3Socket()
          }
          if (localStorage.getItem('theme') === null) {
            localStorage.setItem('theme', 'default')
          }

          let openNewStyle = 0
          if (res.tenantConfig) {
            if (res.tenantConfig['OPEN_NEW_STYLE']) {
              openNewStyle = res.tenantConfig['OPEN_NEW_STYLE']
            }
          }
          this.$message({
            type: 'success',
            message: this.$t('loginSucceeded'),
            duration: 1000,
          })
          clearInterval(this.myVar)
          this.firstRouter(openNewStyle)
          try {
            loginCollection('SUCCESS', new Date().getTime())
            this._getRecordFlag()
          } catch (error) {
            console.log(error)
          }
        } else {
          this.errLogin(state)
        }
      })
    },
    getCloudRoomUrl() {
      if (this.rtcType === 'srs') {
        //  连接注册新媒体平台 服务
        register()
        walkieRegist()
      } else if (this.rtcType === 'mediasoup') {
        loginWalkie()
        // 连接mediasoup
        loginMVCPUtil()
      }
    },
    // 设置默认中心点
    setCenterPoint() {
      return new Promise((resolve, reject) => {
        try {
          // 第一次中心点默认设置为广州
          getMapCenter().then(res => {
            if (res && res.data) {
              setSession('centerPoint', JSON.stringify(res.data))
              resolve()
            } else {
              setSession('centerPoint', JSON.stringify(this.markerPoint))
              resolve()
            }
          })
        } catch {
          // 向下兼容版本
          setSession('centerPoint', JSON.stringify(this.markerPoint))
          resolve()
        }
      })
    },
    // 登录状态异常
    errLogin(state) {
      loginCollection('FAIL', new Date().getTime())
      if (state === 903) {
        this.showCode = true
        this.refreshClick()
      } else if (state === 908 || state === 909) {
        this.getWxCode()
      } else if (state === 917) {
        this.showCode = false
      }
    },
    // 登录成功后根据权限排序跳转页面路由
    async firstRouter() {
      //设置中心点
      await this.setCenterPoint()
      // 根据租户配置OPEN_NEW_STYLE新版界面 0：关闭 1：开启 2：默认进入
      this.$router.push({ path: '/newIndex/newHome' })
      // 更新样式引入
      import('@/style/new-index.styl')
    },
    /**
     * 取min到max间随机数
     */
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    /**
     * 重新取验证码
     */
    refreshCode() {
      this.identifyCode = ''
      this.makeCode(4)
    },
    /**
     * 取0 - 10随机数
     * @param l 验证码长度
     */
    makeCode(l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    },
    // 判断是否已经登录
    checkHasLogin() {
      if (getSession('HWSecurity_access_token')) {
        this.$router.push({ path: '/index' })
      }
    },
    // 微信扫码点击确定后请求登录
    weChatBound() {
      let code = getUrlParam('code')
      let state = getUrlParam('state')
      if (code !== null && state !== null) {
        this.gologin()
      } else {
        if (this.mode === false) {
          this.activeName = 'first'
        } else {
          this.getWxCode()
        }
      }
    },
    _getRecordFlag() {
      getRecordFlag().then(res => {
        if (res.state === 0) {
          let data = res.data
          data.forEach(element => {
            if (element.transcribe === 'TRANSCRIBE_REAL_VIDEO') {
              setSession('TRANSCRIBE_REAL_VIDEO', element.value)
            } else if (element.transcribe === 'TRANSCRIBE_LIVE') {
              setSession('TRANSCRIBE_LIVE', element.value)
            } else if (element.transcribe === 'TRANSCRIBE_LIVE_MODE') {
              this.$store.commit('changeLiveMode', element.value)
            }
          })
        }
      })
    },
    // 跳转帮助网站
    toHelp() {
      window.open('https://intranet.iot.huaweisoft.com:6965/help/icpfo-platform/web.html')
    },
  },
  mounted() {
    this.checkHasLogin()
  },
  watch: {
    // 监听路由变化
    $route: {
      handler() {
        this.weChatBound()
        this.getWxCode()
      },
      deep: true,
    },
  },
  created() {
    // 关闭对讲
    this.$store.commit('walkieShow', false)
    let code = getUrlParam('code')
    let state = getUrlParam('state')
    if (code === null && state === null) {
      this.mode = false
      this.activeName = 'first'
    }
    // 获取验证码增加随机数，防止读取缓存
    this.refreshClick()
    if (getCookie('username') && getCookie('password')) {
      let ckUsername = getCookie('username')
      let ckPassword = getCookie('password')
      this.username = ckUsername
      this.password = ckPassword
      this.checked = true
    }
    if (location.host.indexOf('huaweisoft.com') === -1) {
      changeFavicon('favicon2.ico')
    } else {
      changeFavicon('favicon.ico')
    }
  },
  computed: {
    ...mapGetters(['isCloud', 'rtcType']),
    // 返回当前年份
    _year: function() {
      let Now = new Date()
      return Now.getFullYear()
    },
    isHuaWei: function() {
      return location.host.indexOf('huaweisoft.com') === -1 ? false : true
    },
    customer: function() {
      return location.host.indexOf('iot.julingshen.com.cn') === -1 ? false : true
    },
    SYS_NAME: function() {
      return localStorage.getItem('SYS_NAME')
    },
    SYS_ICON: function() {
      return localStorage.getItem('SYS_ICON')
    },
    CPMPANY_ICON: function() {
      return localStorage.getItem('CPMPANY_ICON')
    },
    SYS_WEBSITE: function() {
      return localStorage.getItem('SYS_WEBSITE')
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'

.login
  height 100%
  width 100%
  overflow hidden
  bg-image('~@/icon/loginbg.png')
  -moz-background-size 100% 100%
  background-size 100% 100%
  .pic-left
    position absolute
    bottom 20%
    left 14%
    overflow hidden
    .inner-pic
      // width 100%
      img
        width 619px
    span
      padding-left 14px
      letter-spacing 3px
      padding-bottom 3px
      box-sizing border-box
      font-size 48px
      color #ffffff
      font-family Regular
  .login-table
    position absolute
    bottom 22%
    left 48%
  .login_top
    div
      display: flex
      justify-content: center
      align-items: center
      .company-name
        font-size 32px
        // line-height 32px
        font-weight bold
        color #2FE4FF
        letter-spacing 2px
        text-shadow 1px 2px 2px rgba(7, 24, 88, 0)
        background linear-gradient(0deg, #4BB9FF 20.537109375%, #FFFFFF 50.6337890625%)
        margin-left 5px
        -webkit-text-fill-color transparent
        -webkit-background-clip text
        padding-bottom: 8px
      img
        width 513px
        height 41px
      .top-icon
        width 42px
        height 42px
        vertical-align: middle
  .login_com
    margin-top 4%
    width 560px
    min-height 360px
    // height 100%
    padding 20px 80px 50px 55px
    box-sizing border-box
    background-color white
    border-radius 4px
    position relative
    .el-input
      width 420px!important
    .login_title
      color #0E65DD
      text-align center
      border-bottom 1px solid #EAEAEA
      line-height 50px
      span
        font-size: 18px
    .login_username
      position relative
      height 43px
      background-color #ffffff
      border-radius 7px
      margin 21px 0 0 0
      .icon_username
        bg-image('~@/icon/user.png')
        width 21px
        height 24px
        position absolute
        left 20px
        top 11px
      .input_username
        border 1px solid #D2D2D2
        border-radius 2px
        position absolute
        top 0
        width 100%
        height 43px
        box-sizing border-box
        background-color transparent
        font-family MiscrosoftYaHeiUI
        font-size 17px
        padding-left 60px
        color #045ba4 !important
      p
        font-size 14px
        padding-left 20px
        color #ed3f14
        padding-top 43px
        visibility hidden
    .login_password
      position relative
      height 43px
      background-color #ffffff
      border-radius 7px
      margin 20px 0 0 0
      .icon_password
        bg-image('~@/icon/password.png')
        width 21px
        height 24px
        position absolute
        left 20px
        top 11px
      .input_password
        border 1px solid #D2D2D2
        border-radius 2px
        position absolute
        top 0
        width 100%
        height 43px
        box-sizing border-box
        background-color transparent
        font-family MiscrosoftYaHeiUI
        font-size 16px
        color #045ba4 !important
        padding-left 60px
      p
        font-size 14px
        padding-left 20px
        color #ed3f14
        padding-top 43px
        visibility hidden
    .login_code
      // margin 20px 20px 0
      position relative
      height 43px
      background-color #ffffff
      border-radius 7px
      margin 20px 0 0 0
      .vertical_err
        bg-image('~@/icon/code.png')
        width 21px
        height 24px
        position absolute
        left 20px
        top 11px
      .input_code
        border 1px solid #D2D2D2
        border-radius 2px
        position absolute
        top 0
        width 100%
        height 43px
        box-sizing border-box
        background-color transparent
        font-family MiscrosoftYaHeiUI
        font-size 16px
        color #045ba4 !important
        padding-left 60px
      .refreshCode
        position absolute
        right 0
        top 1.66px
        img
          width 110px
          height 40px
      .el-input
        width 165px !important
      p
        font-size 14px
        padding-left 16px
        color #ed3f14
        padding-top 46px
        visibility hidden
    .login_checkbox
      display flex
      margin 2px 0px
      justify-content space-between
      label
        input
          width 8px
          height 20px
          vertical-align middle
          display none
        p
          flex 1
          font-size 14px
          color #999999
          display inline
          padding-left 10px
          cursor pointer
      span
        color #999999
        cursor pointer
        line-height 40px
    .word
      display: flex
      align-items center
      .el-select
        width: 80px
        >>>.el-input
            width 100% !important
        >>>.el-input__inner
            color #409EFF
            padding-right 10px!important
        >>>.el-input__suffix
            right -5px!important
    .phoneCode
      position absolute
      right 10px
      top 50%
      transform translate(0, -50%)
      display inline-block
      width 110px
      background #86B2EE
      text-align center
      color #fff
      line-height 30px
      font-size 16px
      border-radius 2px
      cursor pointer
    .login_btn
      margin 23px 0px 0px
      text-align center
      line-height 43px
      .el-button
        width 100%
        height 43px
        padding 0 0
        border-radius 2px
        border none !important
        background-color #0E65DD
      .el-button:active
        background-color #0b77f4
        span
          color #fff
      .back-login
        color #999
        cursor pointer
    .QRBtn
      position absolute
      right 0
      top 0
      width 70px
      height 70px
  .weixin
    margin-top 4%
    width 560px
    height 420px; /* no */
    box-sizing border-box
    background-color white
    border-radius 4px
    position relative
    .QRBtn
      position absolute
      right 0
      top 0
      width 70px
      height 70px
  .login-hint
    color #ea2b2b
    font-size 14px
    text-align center
    width 95%
    margin-top 5px
  .bottom_info
    position absolute
    bottom 0
    left 50%
    transform translate(-50%, -50%)
    img
      vertical-align middle
      margin-right 6px
    span
      cursor pointer
      vertical-align middle
      font-size 12px
      margin-bottom 36px
      width 100%
      text-align center
      color #a6d0fb
      font-family Regular
      letter-spacing 1px
input::-webkit-input-placeholder
  font-family MiscrosoftYaHeiUI
  font-size 18px
  color #999999
.input_img
  bg-image('~@/icon/loginInput.png')
  display block
  width 398px
  height 50px
#checkbtn + label
  display inline-block
  vertical-align middle
  border 1px solid #D2D2D2
  border-radius 2px
  width 16px
  height 16px
#checkbtn:checked + label
  display inline-block
  width 16px
  height 16px
  vertical-align middle
  bg-image('~@/icon/ic_jizhumima.png')
input:-webkit-autofill
  /* -webkit-text-fill-color #fff !important */
  transition background-color 50000s ease-in-out 0s
.icon_phone
  bg-image('~@/icon/ic_phone.png')
  width 21px
  height 24px
  position absolute
  left 20px
  top 11px
.icon_code
  bg-image('~@/icon/ic_code.png')
  width 21px
  height 24px
  position absolute
  left 20px
  top 11px
#wxbox
  width 100%
  display flex
  justify-content center
>>>.el-tabs__nav-scroll
  justify-content center
  display flex
>>>.el-input__inner
  border none
@media screen and (max-width 1366px)
  .login
    .title
      margin-left 0
      justify-content center
    >>> .el-col
      margin-left 0
      width 61.83333%
      .login_com
        height 100%
        margin-top 31%
    .pic-left
      bottom 26%
@media screen and (max-height 768px)
  .login
    .title
      margin-top 4.5%
@media screen and (min-aspect-ratio 1690 / 800)
  .login
    .title
      margin-top 4.5%
@media screen and (min-aspect-ratio 1860 / 800)
  .login
    .title
      margin-top 2.5%
.icon-show
  position absolute
  right 10px
  top 10px
  width 20px
  cursor pointer
</style>
